<template>
  <div>

    <div class="row px-3 mt-4 mb-4">
      <div class="col-12 col-md-4 col-lg-4" v-if="duties_output_permission > 0">
        <div class="card p-2 border-card shadow">
          <p class="text-primary">
            {{ __("forms.EvaluationChart.questions.question26.avgDuties") }}
          </p>
          <p class="text-right h3">{{ outputDuties.toFixed(2) || "&nbsp;" }}</p>
        </div>
      </div>
      <div class="col-12 col-md-4 col-lg-4 mb-4" v-if="activites_output_permission > 0">
      <div class="card p-2 border-card shadow">
          <p class="text-primary">
            {{ __("forms.EvaluationChart.questions.question26.avgActivities") }}
          </p>
          <p class="text-right h3">{{ outputActivities.toFixed(2) || "&nbsp;" }}</p>
        </div>
      </div>
      <div class="col-12 col-md-4 col-lg-4 mb-4" v-if="tasks_output_permission > 0">
        <div class="card p-2 border-card shadow">
          <p class="text-primary">
            {{ __("forms.EvaluationChart.questions.question26.avgTasks") }}
          </p>
          <p class="text-right h3">{{ outputTasks.toFixed(2) || "&nbsp;" }}</p>
        </div>
      </div>
    </div>

    <div>
      <div v-if="permission > 1">
        <!-- <label>Aggiungi Compito</label> -->
        <div class="row mb-4">
          <button
            type="button"
            class="btn btn--green ml-3"
            data-toggle="modal"
            data-target="#addTaskModal"
          >{{ __("forms.questionsLabel.addNewTask") }}
          </button>
        </div>
        <div class="row mt-5 d-none">
          <div class="col-3">
            <label>{{ __("forms.questionsLabel.duty") }}</label>
            <select
              v-model="newDuty"
              class="form-control"
              @change="
                populateSelect(model_activity, 'activity', 'duty_id', $event)
              "
            >
              <option v-for="duty in duties" :value="duty.id" :key="duty.id">
                {{ duty.name }}
              </option>
            </select>
          </div>
          <div class="col-3">
            <label>{{ __("forms.questionsLabel.activity") }}</label>
            <select
              v-model="newActivity"
              class="form-control"
              @change="
                populateSelect(model_task, 'task', 'activity_id', $event)
              "
            >
              <option v-for="activity in activities" :value="activity.id">
                {{ activity.name }}
              </option>
            </select>
          </div>
          <div class="col-3">
            <label>{{ __("forms.questionsLabel.task") }}</label>
            <select v-model="newTask" class="form-control">
              <option v-for="task in tasks" :value="task.id">
                {{ task.name }}
              </option>
            </select>
          </div>
          <div class="col-3 aggiungi-task">
            <a href="#" class="btn btn--green" @click="addTask()"
              >{{ __("forms.questionsLabel.addNewTask") }}</a
            >
          </div>
        </div>
      </div>
      <!--          ELEMENTI INSERITI  personTasks-->

      <div class="container-fluid">
        <div class="row w-100">
          <div class="accordion w-100" id="accordionTasks">
            <div
              class="mb-3"
              v-for="duty in tree"
              :key="duty.duty_name + duty.duty_id"
            >
              <div class="">
                <div class="mb-0">
                  <button
                    class="btn w-100 border-accordion-item"
                    type="button"
                    data-toggle="collapse"
                    :data-target="'#duty' + duty.duty_id"
                  >
                    <div class="row w-100 align-items-center">
                      <div class="col-12 col-md-6 text-left">
                        <h4>
                          {{ duty.duty_name }}
                        </h4>
                      </div>
                      <div class="col-12 col-md-6 text-right">
                        <h4>
                          {{ __("forms.OrganizationalUnit.valutation") }}:
                          {{
                            finalValues.dutiesFinalValues[
                              duty["duty_id"]
                            ].tasksFinalValues.toFixed(2)
                          }}
                          | {{ __("forms.OrganizationalUnit.affinity") }}:
                          {{
                            finalValues.dutiesFinalValues[duty["duty_id"]]
                              .affinity
                          }}
                        </h4>
                      </div>
                    </div>
                  </button>
                </div>
              </div>

              <div
                :id="'duty' + duty.duty_id"
                class="collapse"
                data-parent="#accordionTasks"
              >
                <div class="row mt-3">
                  <div class="col-12 col-md-6 col-lg-6 mb-2">
                    <div class="card p-2 border-card shadow">
                      <p class="text-primary">
                        {{ __("forms.OrganizationalUnit.valutation") }}
                      </p>
                      <p class="text-right h3">
                        {{
                          finalValues.dutiesFinalValues[
                            duty["duty_id"]
                          ].tasksFinalValues.toFixed(2)
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-6 mb-2">
                    <div class="card p-2 border-card shadow">
                      <p class="text-primary">
                        {{ __("forms.OrganizationalUnit.affinity") }}
                      </p>
                      <p class="text-right h3">
                        {{
                          finalValues.dutiesFinalValues[duty["duty_id"]]
                            .affinity
                        }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="pt-5">
                  <div
                    v-for="activity in duty.children"
                    :key="activity.activity_id"
                    class="row mb-4"
                  >
                    <div class="col-12">
                      <div class="row">
                        <div class="col-6">
                          <p class="text-primary">
                           {{ activity.activity_name }}
                          </p>
                        </div>
                        <div class="col-6 text-right pr-5">
                          <span class="text-voice-title">{{ __("forms.OrganizationalUnit.valutation") }}:</span>
                          <span class="text-voice-value">{{
                            finalValues.activitiesFinalValues[
                              activity["activity_id"]
                            ].tasksFinalValues.toFixed(2)
                          }}</span>
                          | <span class="text-voice-title">{{ __("forms.OrganizationalUnit.affinity") }}:</span>
                          <span class="text-voice-value">{{
                            finalValues.activitiesFinalValues[
                              activity["activity_id"]
                            ].affinity
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-12"
                      v-for="(task, k) in activity.children"
                      :key="k"
                    >
                      <div class="row mt-3">
                        <div class="col-6">
                          <label class="text-voice-title mb-2">{{ __("forms.Activities.task") }}</label>
                          <div class="d-flex align-items-center">
                            <a v-if="permission > 1" class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove mx-1" @click="rmTaskPerson(task.task_id)"> <i class="fas fa-trash"></i>
                            </a>
                            <span class="text-voice-value ml-2">{{ task["task_name"] }}</span>
                          </div>
                        </div>
                        <div class="col-3">
                          <div v-if="permission > 1" style="">
                            <label class="text-voice-title mb-2">{{ __("forms.Activities.level") }}</label>
                            <select
                              class="form-control"
                              @change="
                                updateTask($event, task.task_id, 'level_id')
                              "
                              v-model="
                                personTasks[task.task_id].task_person_level_id
                              "
                            >
                              <option
                                v-for="level in levels"
                                :value="level.id"
                                :key="level.id"
                              >
                                {{ level.name }}
                              </option>
                            </select>
                          </div>
                          <div v-else>
                            <label class="text-voice-title mb-2">{{ __("forms.Activities.level") }}</label>
                            <div class="text-voice-value">
                              {{
                                personTasks[task.task_id].task_person_level_name
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="col-3">
                          <div class="form-group m-0" v-if="permission > 1">
                            <label class="text-voice-title mb-2">{{ __("forms.Activities.note") }}</label>
                            <textarea
                              class="form-control textarea-unset"
                              rows="1"
                              @change="updateTask($event, task.task_id, 'note')"
                              :placeholder="personTasks[task.task_id].note"
                              style="
                                height: calc(1.5em + 0.75rem + 2px);
                                padding: 0.375rem 0.75rem;
                              "
                            ></textarea>
                          </div>
                          <div v-else>
                            <label class="text-voice-title mb-2">{{ __("forms.Activities.note") }}</label>
                            <div class="text-voice-value">
                              {{ personTasks[task.task_id].note }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="addTaskModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addTaskModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content" style="border-radius: 1.5rem">
          <div class="modal-header">
            <h5 class="modal-title" id="addTaskModalLabel">
              {{ __("forms.questionsLabel.addNewTask") }}
            </h5>
            <button
              type="button"
              ref="addTaskCloseModal"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row py-5">
              <div class="col-4">
                <label>{{ __("forms.questionsLabel.duty") }}</label>
                <select
                  v-model="newDuty"
                  class="form-control"
                  @change="
                    populateSelect(
                      model_activity,
                      'activity',
                      'duty_id',
                      $event,
                    )
                  "
                >
                  <option
                    v-for="duty in duties"
                    :value="duty.id"
                    :key="duty.id"
                  >
                    {{ duty.name }}
                  </option>
                </select>
              </div>
              <div class="col-4">
                <label>{{ __("forms.questionsLabel.activity") }}</label>
                <select
                  v-model="newActivity"
                  class="form-control"
                  @change="
                    populateSelect(model_task, 'task', 'activity_id', $event)
                  "
                >
                  <option
                    v-for="activity in activities"
                    :value="activity.id"
                    :key="activity.id"
                  >
                    {{ activity.name }}
                  </option>
                </select>
              </div>
              <div class="col-4">
                <label>{{ __("forms.questionsLabel.task") }}</label>
                <select v-model="newTask" class="form-control">
                  <option v-for="task in tasks" :value="task.id" :key="task.id">
                    {{ task.name }}
                  </option>
                </select>
              </div>
              <div class="col-12 text-right aggiungi-task">
                <button
                  type="button"
                  class="btn btn--green mt-3"
                  @click="addTask()"
                >
                {{ __("forms.questionsLabel.addNewTask") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.populateSelect(this.model_duty, "duty");
    this.populateAnswersTasks();
  },
  props: {
    levels: {
      type: Array,
      required: true,
    },
    model_duty: {
      type: String,
      required: true,
    },
    model_activity: {
      type: String,
      required: true,
    },
    model_task: {
      type: String,
      required: true,
    },
    permission: {
      type: Number,
      required: true,
    },
    evaluation_chart_id: {
      type: Number,
      required: true,
    },
    is_admin: {
      type: Boolean,
      required: true,
    },
    question_survey_id: {
      type: Number,
      required: true,
    },
    owner_person_id: {
      type: Number,
      required: true,
    },
    duties_output_permission: {
      type: Number,
      required: true,
    },
    activites_output_permission: {
      type: Number,
      required: true,
    },
    tasks_output_permission: {
      type: Number,
      required: true,
    },
    empty_values: {
      type: Boolean,
      required: false,
      default: false,
    },
    alert_label_no_task: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      newDuty: null,
      newActivity: null,
      newTask: null,

      duties: null,
      activities: null,
      tasks: null,

      outputDuties : 0,
      outputActivities : 0,
      outputTasks : 0,

      personTasks: [],
      tree: null,
      finalValues: [],

      //default
      action: "",
      editing: true,
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
      userUrl: this.is_admin ? "" : "-user",
      newClientName: null,
      newProjectName: null,
    };
  },
  methods: {
    updateTask(event, task_id, type) {
      axios
        .put("/tasks-people-chart-update-task", {
          chart: {
            task_id: task_id,
            type: type,
            value: event.target.value,
            evaluation_chart: this.evaluation_chart_id,
            question_survey: this.question_survey_id,
          },
        })
        .then((response) => {
          this.populateAnswersTasks();
        });
    },

    rmTaskPerson(task_id) {
      Vue.swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.value) {
            axios
              .delete(
                "/tasks-people-chart-delete-task" +
                  "/" +
                  this.evaluation_chart_id +
                  "/chart/" +
                  this.question_survey_id +
                  "/survey",
                {
                  params: {
                    task_id: task_id,
                  },
                },
              )
              .then((response) => {
                this.populateAnswersTasks();
              })
              .catch(function (error) {
                alert(error);
              });
          }
        });
    },

    addTask() {
      if (
        this.newTask == null ||
        this.newTask == "null" ||
        this.newTask == ""
      ) {
        Vue.swal.fire({ title: this.alert_label_no_task });
        return;
      }

      axios
        .post("/tasks-people-chart-set-new-task", {
          chart: {
            task_id: this.newTask,
            evaluation_chart: this.evaluation_chart_id,
            question_survey: this.question_survey_id,
          },
        })
        .then((response) => {
          this.newTask = this.newActivity = this.newDuty = null;
          this.populateAnswersTasks();
          this.$refs.addTaskCloseModal.click();
        });
    },
    populateAnswersTasks() {
      axios
        .get(
          "/tasks-people-chart-get-tasks" +
            "/" +
            this.evaluation_chart_id +
            "/chart/" +
            this.question_survey_id +
            "/survey",
          {},
        )
        .then((response) => {
          this.personTasks = response.data.values;
          this.tree = Object.values(response.data.tree).filter(
            (el) => el.duty_id !== null,
          );

          this.finalValues = response.data.final_values;
          this.outputDuties = response.data.outputs.duties;
          this.outputActivities = response.data.outputs.activities ;
          this.outputTasks = response.data.outputs.tasks;
        })
        .catch(function (error) {
          alert(error);
        });
    },
    populateSelect(model, selectName, parentField, event) {
      axios
        .get("/tasks-people-chart-filter-values", {
          params: {
            parentModel: model,
            parentName: parentField,
            objectId: event !== undefined ? event.target.value : null,
          },
        })
        .then((response) => {
          switch (selectName) {
            case "duty":
              this.duties = response.data;
              break;
            case "activity":
              this.activities = response.data;
              break;
            case "task":
              this.tasks = response.data;
              break;
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },
  },
};
</script>

<style scoped>
.textarea-unset {
  resize: both !important;
}

</style>
